/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type CreateSubscriptionPathParams = NonNullable<operations['createSubscription']['parameters']['path']>;

export type CreateSubscriptionRequestBody = OperationRequestBodyContent<operations['createSubscription']>;

export interface Input extends CreateSubscriptionPathParams {
  apiVersion?: string;
  body: CreateSubscriptionRequestBody;
}

export async function createSubscription(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/integrations/{integrationKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
